<template>
  <BaseButton
    :text="displayText"
    :class="{'button-selected': selected, 'filter-button': true}"
    variant="secondary"
    @click="emit('click', $event)"/>
</template>

<script setup>
import { computed } from 'vue'
import BaseButton from '@shared/components/ADORN/BaseButton'

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})
const props = defineProps({
  option: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const displayText = computed(() => {
  // Add inch symbol for display (backend sends numeric values only)
  return `${props.option.text}"`
})
</script>

<style lang="scss" scoped>
.filter-button {
  font-family: $body-font-family;
  white-space: nowrap;
  &:disabled {
    border-style: dashed;
    user-select: none;
  }
  &.selected {
    color: $plum;
    border-color: $plum;
    background-color: rgba($plum, 0.1);
  }
}
.button-selected {
  border-color: $white !important;
  background-color: $plum !important;
  color: $white !important;
}
</style>
